import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue';
import CError from '@/components/shared/CError.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CRecaptcha',
  props: {
    value: null,
    siteKey: { default: process.env.VUE_APP_RECAPTCHA_SITE_KEY },
    error: { type: Boolean },
    errorMsg: null
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ({
    (event: 'input', token: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: string, siteKey: string, error?: boolean, errorMsg?: string };





const container = ref<HTMLElement | undefined>();
const widgetId = ref<number | undefined>();

// api.js?render=explicit is loaded from public/index.html, but it may not have resolved yet
const waitForGrecaptcha = () =>
    new Promise<void>((resolve) => {
        if (window.grecaptcha?.render) return resolve();
        const interval = setInterval(() => {
            if (!window.grecaptcha?.render) return;
            clearInterval(interval);
            resolve();
        }, 100);
    });

const reset = () => {
    if (widgetId.value == undefined) return;
    window.grecaptcha?.reset(widgetId.value);
    emit('input', '');
};

onMounted(async () => {
    await waitForGrecaptcha();
    if (!container.value || !window.grecaptcha) return;

    widgetId.value = window.grecaptcha.render(container.value, {
        sitekey: props.siteKey || '',
        callback: (token: string) => emit('input', token),
        'expired-callback': () => emit('input', ''),
        'error-callback': () => emit('input', '')
    });
});

onBeforeUnmount(reset);

expose({ reset });

return { __sfc: true,props, emit, container, widgetId, waitForGrecaptcha, reset, CError }
}

})